module.exports = __webpack_public_path__ + "img/the witch of scarlet dreams.a28e216e.png";